import React from 'react';
import './sec4.css'
import Cardsec4 from '../components/common/card-sec4';
import pic15 from '../assets/pic15.png'
import pic16 from '../assets/pic16.png'
import pic17 from '../assets/pic17.png'
import pic18 from '../assets/pic18.png'
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Sec4 = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

 const [animate, setAnimate] = useState(false);
    const [wasInView, setWasInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.querySelector('.sec4');

            if (section) {
                const rect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const isInView = rect.top < windowHeight && rect.bottom > 0;

                if (isInView && !wasInView) {
                    setAnimate(false);
                    setTimeout(() => {
                        setAnimate(true);
                    }, 50);
                    setWasInView(true);
                }

                if (!isInView && wasInView) {
                    setAnimate(false);
                    setWasInView(false);
                }
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [wasInView]);













    return ( 
        <section className={`sec4 ${animate ? 'animate' : ''}`} dir={direction}>
            <article className='container-sec4'>
                <article className='left-part-sec4'>

                    <h1 className='header-sec4'> {t('Why Choose Us')}</h1>
                    <p className='para-sec4'>{t('MusicTicket  is your ultimate destination for discovering and booking tickets to the best music events. We connect you with unforgettable live experiences.')}</p>
                    <article className='container-cards-sec4'>
                        <Cardsec4 
                        img={pic15}
                        title={t('Easy Booking')}
                        para={t('Book tickets in just a few clicks')}/>

                        <Cardsec4 
                        img={pic16}
                        title={t('Secure Payment')}
                        para={t('Enjoy safe transactions with multiple payment options')}/>


                        <Cardsec4 
                        img={pic17}
                        title={t('Instant Confirmation')}
                        para={t('Receive instant booking confirmation via email')}/>






                    </article>




                    

                </article>


                <img className='big-img-sec4' src={pic18} alt='pic'></img>


            </article>
        </section>
     );
}
 
export default Sec4;